import { debounceTime, fromEvent, map, merge, Observable, of, take } from 'rxjs';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class InteractionsService {
  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private hasUserInteracted = false;

  private readonly events$ = this.isBrowser ? merge(
    fromEvent(window, 'pointerdown'),
    fromEvent(window, 'keydown'),
    fromEvent(window, 'scroll')
  ) : undefined;

  waitForUserInteraction(): Observable<boolean> {
    if (this.isBrowser) {
      return this.events$.pipe(
        take(1),
        map(() => {
          if (this.hasUserInteracted) {
            return false;
          }
          this.hasUserInteracted = true;
          return true;
        })
      );
    } else {
      return of(false);
    }
  }

  watchUserInteractions(debounce = 1000): Observable<Event> {
    return this.isBrowser ? this.events$.pipe(debounceTime(debounce)) : of(undefined);
  }
}
